import React from "react";

const UpscEligibilityMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      {/* Nationality Section */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">1. Nationality</h3>
        <p>
          <strong>For IAS & IPS:</strong> Candidate must be a{" "}
          <strong>citizen of India</strong>.
        </p>
        <p>
          <strong>For other services:</strong> Candidate must be either:
        </p>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">A citizen of India</li>
          <li className="list-group-item">A subject of Nepal or Bhutan</li>
          <li className="list-group-item">
            A Tibetan refugee who migrated to India before January 1, 1962, for
            permanent settlement
          </li>
          <li className="list-group-item">
            A person of Indian origin who migrated from Pakistan, Burma, Sri
            Lanka, and some East African countries
          </li>
        </ul>
        <p className="mt-2">
          <strong>Note:</strong> Candidates from the above categories (except
          Indian citizens) must have a{" "}
          <strong>certificate of eligibility</strong> issued by the Government
          of India.
        </p>
      </div>

      {/* Age Limit & Relaxation Section */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">2. Age Limit & Relaxation</h3>
        <p>
          Candidates must be between <strong>21 to 32 years</strong> as of
          August 1st of the exam year.
        </p>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Category</th>
              <th>Age Limit</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>General</td>
              <td>21 to 32 years</td>
            </tr>
            <tr>
              <td>OBC (Non-Creamy Layer)</td>
              <td>21 to 35 years</td>
            </tr>
            <tr>
              <td>SC/ST</td>
              <td>21 to 37 years</td>
            </tr>
            <tr>
              <td>Ex-Servicemen</td>
              <td>5 years relaxation</td>
            </tr>
            <tr>
              <td>Persons with Disabilities</td>
              <td>10 years relaxation</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Educational Qualification */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">3. Educational Qualification</h3>
        <p>
          Candidate must hold a{" "}
          <strong>degree from a UGC-recognized university</strong>. There is no
          minimum percentage requirement.
        </p>
      </div>

      {/* Number of Attempts */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">4. Number of Attempts</h3>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Category</th>
              <th>Maximum Attempts</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>General</td>
              <td>6 attempts</td>
            </tr>
            <tr>
              <td>OBC</td>
              <td>9 attempts</td>
            </tr>
            <tr>
              <td>SC/ST</td>
              <td>Unlimited attempts</td>
            </tr>
            <tr>
              <td>Persons with Disabilities (General/OBC)</td>
              <td>9 attempts</td>
            </tr>
            <tr>
              <td>Persons with Disabilities (SC/ST)</td>
              <td>Unlimited attempts</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UpscEligibilityMain;
